import { IParlamentarianPagedRequest } from '../../../../model/sge/parlamentarian/request/parlamentarian-paged-request';
import { IParlamentarianResponse } from '../../../../model/sge/parlamentarian/response/parlamentarian-response';
import { IPoliticalPartyPagedResponse } from '../../../../model/sge/political-party/response/political-party-paged-response';

export type ParlamentarianSearchState = {
    parameters: IParlamentarianPagedRequest;
    searchTrigger: number;
    politicalParties: IPoliticalPartyPagedResponse[];
    drawer: { open: boolean; record?: IParlamentarianResponse };
};

export enum ACTION_TYPES {
    updateParameter = 'updateParameter',
    triggerSearch = 'triggerSearch',
    setPoliticalParties = 'setPoliticalParties',
    openDrawer = 'openDrawer',
    closeDrawer = 'closeDrawer',
}

export const ParlamentarianSearchReducer = (state: ParlamentarianSearchState, action: any): ParlamentarianSearchState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.updateParameter:
            return { ...state, parameters: { ...state.parameters, ...payload } };
        case ACTION_TYPES.triggerSearch:
            return { ...state, searchTrigger: state.searchTrigger + 1 };
        case ACTION_TYPES.setPoliticalParties:
            return { ...state, politicalParties: payload };
        case ACTION_TYPES.openDrawer:
            return { ...state, drawer: { open: true, record: payload } };
        case ACTION_TYPES.closeDrawer:
            return { ...state, drawer: { open: false } };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
